import type { FormLocale } from '@jlg-website/shared';
import { textFor } from './copy';

type SummaryRowProps = {
  /** What is being confirmed: a formatted slot in the picker, "Now" when calling right away. */
  summary: string;
  locale: FormLocale;
  onChange: () => void;
};

/** The confirmed time and its way back, shown at the top of both confirmation screens. */
export function SummaryRow({ summary, locale, onChange }: SummaryRowProps) {
  return (
    <div className="flex items-center justify-between gap-4 rounded-lg bg-brand-muted-light/30 px-4 py-3">
      <p className="text-sm font-semibold text-brand-text-button">{summary}</p>

      <button
        type="button"
        onClick={onChange}
        className="shrink-0 cursor-pointer text-sm text-brand-accent hover:underline"
      >
        {textFor(locale, 'change')}
      </button>
    </div>
  );
}
